import { RouteLocationNormalized } from "vue-router"

export default (to: RouteLocationNormalized): boolean | undefined => {
  const isDevelopment = process.env.NODE_ENV === "development"
  if (to.name !== "usage" || isDevelopment) return

  const toUrl = new URL(window.location.href)
  toUrl.pathname = "/myaccount/usage"
  window.location.assign(toUrl.toString())
  return false
}
